/* global $ */

var Proj = (function(proj){
    'use strict';

    proj.getProjects = function(params){

        var opt = {
            next: '.js-ajax-projects'
        };
        var issend = false;

        var $next = $(opt.next);
        if($next.length){
            init(params);
        }

        function addItems(data){
            $(opt.next).before(data.content);
        }

        function init(params){
            $next.on('click', function(e){
                var $this = $(this);

                e.preventDefault();

                if(!issend){
                    issend = true;
                    var page = $this.data('page'),
                        object_id = $this.data('objectId');

                    var d = $.extend(true,{
                        _do: 'get_projects',
                        page: page,
                        object_id: object_id,
                    }, params);

                    proj.getAJAX(d)
                        .done(function(json){
                            issend = false;

                            if(json && json.content){

                                addItems(json);

                                $next.data('page', page + 1);
                                var $items = $('.projects__item'),
                                    total = $next.data('total');
                                if($items.length >= total){
                                    $next.remove();
                                }
                            }
                        })
                        .fail(function(){
                            issend = false;
                        });
                }
            });
        }
    };

    return proj;
})(Proj || {});


/*
function getAJAX(data, options) {
    // console.log(data);
    // Адрес на который уходит ajax запрос
    var AJAX_URI = '/json/';

    // Метод запроса по умолчанию
    var AJAX_METHOD = 'post';

    // Таймаут запроса
    var AJAX_TIMEOUT = 5000;

    // dataType ajax запроса по умолчанию
    var AJAX_DATA_TYPE = 'json';

    var url = AJAX_URI;
    var timeout = 0;
    var method = AJAX_METHOD;
    var dataType = AJAX_DATA_TYPE;

    if (options) {
        if (options.url) {
            url = options.url;
        }
        if (options.timeout) {
            timeout = options.timeout;
        }
        if (options.method) {
            method = options.method;
        }

        if (options.dataType) {
            dataType = options.dataType;
        }
    }
    if (data._do) {
        url = url + data._do + '/';
        delete data._do;
    } else {
        if ((options) && (options._do)) {
            url = url + options._do + '/';
        }
    }

    // console.log(url);

    return $.ajax({
        type     : method,
        url      : url,
        data     : data,
        dataType : dataType,
        timeout  : timeout,
    });
}
*/
